<template>
  <v-row class=" px-10 pt-4" >
    <ToolbarTitles :title="title" />
    <v-col>
      <div
        class="filter__container"
        style="display: flex; flex-direction: column; margin-top: -15px"
      >
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-bottom: -25px;
          "
        >
          <v-menu
            v-model="menuFrom"
            ref="menuFrom"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                readonly
                v-bind="attrs"
                v-on="on"
                prepend-icon="fa-calendar"
                v-model="formatDateFrom"
                :label="$tc('changeSchedule.from')"
                required
                :rules="rules"
                class="ml-1"
                style="max-width: 200px"
                rounded
                outlined
                dense
              />
            </template>
            <v-date-picker
              locale="es-es"
              no-title
              scrollable
              v-model="changeDateFrom"
              @input="menuFrom = false"
            >
            </v-date-picker>
          </v-menu>
          <v-menu
            v-model="menuTo"
            ref="menuTo"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                readonly
                v-bind="attrs"
                v-on="on"
                prepend-icon="fa-calendar"
                v-model="formatDateTo"
                :disabled="checkTo == true"
                :label="$tc('changeSchedule.to')"
                style="max-width: 200px; margin-left: 20px"
                rounded
                outlined
                dense
              />
            </template>
            <v-date-picker
              locale="es-es"
              no-title
              scrollable
              v-model="changeDateTo"
              @input="menuTo = false"
            >
            </v-date-picker>
          </v-menu>
          <div class="d-flex">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-simple-checkbox
                    :ripple="false"
                    color="accent"
                    class="mt-2 ml-1"
                    v-model="checkTo"
                  >
                  </v-simple-checkbox>
                </span>
              </template>
              <span>{{ $tc("changeSchedule.caducity") }}</span>
            </v-tooltip>
            <div class="container-refresh">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="button-refresh mr-3 mt-1"
                    small
                    color="#39537a"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="goToRefresh"
                  >
                    <v-img
                      src="../../../assets/icons/actualizar-osc.png"
                      alt="actualizar"
                      max-width="20"
                    />
                  </v-btn>
                </template>
                <span>{{ $tc("workflow.refresh") }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
        <div class="container__filter">
          <div class="filter-toggle" @click="toggleFilter">
            <v-icon v-if="!filterCollapsed">mdi-chevron-down</v-icon>
            <v-icon v-else>mdi-chevron-up</v-icon>
            <h5 class="filter-title">{{ $tc("filter.filters") }}</h5>
          </div>
          <v-expand-transition>
            <div v-show="!filterCollapsed">
              <div class="container__check">
                <div class="check__ac">
                  <h5 style="margin-bottom: -15px">
                    {{ $tc("filter.property") }}
                  </h5>
                  <v-radio-group
                    v-model="getFilter.mine"
                    @change="checkboxChange"
                  >
                    <v-radio
                      :label="$tc('workflow.filters.myActivities')"
                      value="true"
                    ></v-radio>
                    <v-radio
                      :label="$tc('workflow.filters.delegatedActivities')"
                      value="false"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div class="check__ac">
                  <h5 style="margin-bottom: -15px">
                    {{ $tc("filter.state") }}
                  </h5>
                  <v-checkbox
                    :ripple="false"
                    @change="checkboxChange"
                    class="ml-1 checks"
                    :label="$tc('workflow.filters.approved')"
                    v-model="getFilter.approved"
                  ></v-checkbox>
                  <v-checkbox
                    :ripple="false"
                    @change="checkboxChange"
                    class="ml-1 checks"
                    :label="$tc('workflow.filters.rejected')"
                    v-model="getFilter.reject"
                  ></v-checkbox>
                </div>
                <div class="check__ac">
                  <h5 style="margin-bottom: -15px">
                    {{ $tc("filter.action") }}
                  </h5>
                  <v-radio-group
                    v-model="getFilter.pendings"
                    @change="pendingChange"
                  >
                    <v-radio
                      :label="$tc('workflow.filters.pendings')"
                      value="true"
                    ></v-radio>
                    <v-radio
                      :label="$tc('workflow.filters.done')"
                      value="false"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div class="check__ac">
                  <h5 style="margin-bottom: -15px">{{ $tc("filter.type") }}</h5>
                  <v-checkbox
                    :ripple="false"
                    @change="checkboxChange"
                    class="ml-1 checks"
                    :label="$tc('workflow.filters.leaveRequests')"
                    v-model="getFilter.licens"
                  ></v-checkbox>
                  <v-checkbox
                    :ripple="false"
                    @change="checkboxChange"
                    class="ml-1 checks"
                    :label="$tc('workflow.filters.scheduleChangeRequests')"
                    v-model="getFilter.schedules"
                  ></v-checkbox>
                  <v-checkbox
                    :ripple="false"
                    @change="checkboxChange"
                    class="ml-1 checks"
                    :label="$tc('workflow.filters.overtimeRequests')"
                    v-model="getFilter.hsExtra"
                  ></v-checkbox>
                  <v-checkbox
                    :ripple="false"
                    @change="checkboxChange"
                    class="ml-1 checks"
                    :label="$tc('workflow.filters.loggedLeaves')"
                    v-model="getFilter.licF"
                  ></v-checkbox>
                  <v-checkbox
                    :ripple="false"
                    @change="checkboxChange"
                    class="ml-1 checks"
                    :label="$tc('workflow.filters.delegations')"
                    v-model="getFilter.dele"
                  ></v-checkbox>
                </div>
              </div>
            </div>
          </v-expand-transition>
        </div>
      </div>
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-row>
</template>

<script>
import activities from "../../../store/workflow/activities";
import filters from "../../../store/workflow/filters";
import ToolbarTitles from "../../Complement/ToolbarTitles.vue";
import moment from "moment";
import Loader from "../../Complement/Loader.vue";
export default {
  components: { Loader, ToolbarTitles },
  props: {
    title: String,
  },
  data() {
    return {
      menuFrom: false,
      menuTo: false,
      check: null,
      isLoading: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      dateFrom: moment().format("YYYY-MM-DD"),
      dateTo: null,
      textAlert: "",
      error: false,
      color: "",
      alert: false,
      filterDefault: {
        mine: "true",
        approved: true,
        reject: true,
        pendings: "true",
        licens: true,
        schedules: true,
        hsExtra: true,
        licF: true,
        dele: true,
      },

      filterCollapsed: true,
    };
  },

 async mounted() {
    await activities.dispatch("getFilter").then(()=>{
       if (Object.keys(activities.state.filter).length === 0) {
            const today = new Date().toISOString().split('T')[0] + "T00:00:00.000Z";
            const payload = {
            operId:Number(localStorage.getItem("operId")),
            from:today,
            to:null,
            mios: true,
            pending: true,
            approved: true,
            rejected: true,
            licenses: true,
            cSchedule: true,
            hsExtra: true,
            licF: true,
            dele: true
          };
         
          filters.commit("setNew", payload)
          filters.dispatch("new").then(()=>{
            activities.dispatch("getFilter")
          })
          
        } 
    });
  },
  computed: {
    getFilter() {
      const filter =
        Object.keys(activities.state.filter).length === 0
          ? this.filterDefault
          : activities.state.filter;
      // Convertir mine y pendings a booleanos
      filter.mine = filter.mine ? "true" : "false";
      filter.pendings = filter.pendings ? "true" : "false";
      return filter;
    },
    //formateo la fecha
    formatDateFrom() {
      return this.changeDateFrom == null
        ? moment(this.dateFrom).format("DD-MM-YYYY")
        : moment(this.changeDateFrom).format("DD-MM-YYYY");
    },

    formatDateTo() {
      if (this.checkTo) {
        return "";
      }
      let dateTo =
        this.changeDateTo == null
          ? moment(this.changeDateFrom).add(1, 'day').format("DD-MM-YYYY")
          : moment(this.changeDateTo).format("DD-MM-YYYY");
         this.changeDateTo = moment(dateTo, "DD-MM-YYYY").format("YYYY-MM-DD");
      return dateTo;
    },
    // cambio la fecha y activo el dispatch
    changeDateFrom: {
      get() {
        return !activities.state.filter
          ? this.dateFrom
          : activities.state.filter.from;
      },
      set(newDate) {
        if (newDate > activities.state.filter.to || newDate > this.dateTo) {
          activities.state.filter.to = newDate;
          this.dateTo = newDate;
          this.setDateTo(newDate);
        }
        activities.state.filter.from = newDate;
        this.dateFrom = newDate;
        this.setDate(newDate);
      },
    },
    changeDateTo: {
      get() {
        return !activities.state.filter
          ? this.dateTo
          : activities.state.filter.to;
      },
      set(date) {
        if (
          (!activities.state.filter.from ||
            date < activities.state.filter.from) &&
          date < this.dateFrom
        ) {
          activities.state.filter.from = date;
          this.dateFrom = date;
          this.setDate(date);
        }
        activities.state.filter.to = date;
        this.dateTo = date;
        this.setDateTo(date);
      },
    },
    checkTo: {
      get() {
        return activities.state.checkTo;
      },
      set(newValue) {
        this.setCheckTo(newValue);
      },
    },
  },
  methods: {
    setCheckTo(value) {
      activities.commit("setCheckTo", value);
    },
    setDate(date) {
      activities.commit("setDateFrom", date);
    },
    setDateTo(date) {
      activities.commit("setDateTo", date);
    },
    pendingChange(event) {
      const isPending = event === "true";
      activities.commit("setChangeEvent", isPending);
      this.goToRefresh();
    },
    checkboxChange() {
      this.goToRefresh();
    },
    goToRefresh() {
      let filter = {
        ...activities.state.filter,
        to:
          activities.state.checkTo == true ? null : activities.state.filter.to,
        checkTo: activities.state.checkTo,
      };

      filter.mine = filter.mine === "true";
      filter.pendings = filter.pendings === "true";

      this.isLoading = true;
      activities.commit("setEditFilter", filter);
      activities
        .dispatch("editFilter")
        .then(async () => {
          await activities.dispatch("getActivities").then(() => {
            if (activities.state.activities.length == 0) {
              this.alert = true;
              this.color = "#FF8D58";
              this.textAlert = this.$tc("workflow.noActivities");
            }
          });
          setTimeout(() => {
            this.alert = false;
          }, 1000);

          this.isLoading = false;
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = "Error al guardar el filtro";
          this.isLoading = false;
        });
    },

    toggleFilter() {
      this.filterCollapsed = !this.filterCollapsed;
    },
  },
};
</script>

<style scoped>
.container__filter {
  display: flex;
  flex-direction: column;
}

.container-refresh {
  display: flex;
  justify-content: flex-end;
  height: 24px;
}

.button-refresh {
  background-color: rgb(57, 83, 122);
  border-color: rgb(57, 83, 122);
  height: 30px !important;
  border-radius: 24px;
}

.filter__container {
  background: white !important;
  width: 80%;
  border-radius: 10px;
  border: 1px solid #5e95f5;
  margin-left: 10px !important;
  box-shadow: 3px 5px 6px 1px rgba(0, 0, 0, 0.75);
  padding: 15px;
}

.container__date {
  height: 46px;
}

.checks {
  height: 15px;
}

.check__ac {
  flex: 1 1 1 1 150px;
}

.container__check {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.filter-toggle {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  margin-bottom: -10px;
}

.filter-title {
  margin-right: 10px;
}

h5 {
  color: #586271;
  font-weight: bold !important;
}
</style>
